import {IFieldDescriptor} from '@/features/mixer'
import _ from 'lodash'

export interface IWordProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> {
  descriptor: IFieldDescriptor
  label?: string
  value?: number
  range?: {min: number; max: number}
  actionsLeft?: (field: IFieldDescriptor) => React.ReactElement
  actionsRight?: (field: IFieldDescriptor) => React.ReactElement
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, field: IFieldDescriptor) => void
}

export function Word(props: IWordProps) {
  const {
    descriptor,
    label: propsLabel,
    value,
    range,
    actionsLeft,
    actionsRight,
    onClick,
    // div
    className,
    ...rest
  } = {
    range: {min: 0, max: 1},
    ...props,
  }

  const {max} = range

  const _label = propsLabel || descriptor.label

  const classNames = _.chain(['word', className]).compact().join(' ').value()

  return (
    <div
      className={classNames}
      {...rest}
      onClick={onClick ? (e) => onClick(e, descriptor) : undefined}
    >
      {actionsLeft ?
        <div className='actions left'>{actionsLeft(descriptor)}</div>
      : null}
      <div className='middle'>
        {/* <div className='value' style={_.isNumber(value) ? {
                width: `${value / max * 100}%`,
            } : undefined} /> */}
        <div
          className='no-value'
          style={
            _.isNumber(value) ?
              {
                right: 0,
                width: `${(1 - value / max) * 100}%`,
              }
            : undefined
          }
        />
        <div className='label'>
          {value !== undefined ?
            <>
              {_label}: {_.isNumber(value) ? value.toFixed(2) : value}
            </>
          : <>{_label}</>}
        </div>
      </div>
      {actionsRight ?
        <div className='actions right'>{actionsRight(descriptor)}</div>
      : null}
    </div>
  )
}
